/* eslint-disable max-len */
import { Box } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
    useSelectorAppLoading,
    useSelectorIsInitialized,
    useSelectorIsOneRosterActivatedSchool,
    AppState
} from '../../app';
import { LoadingState } from '../../app/state/app.types';
import { ErrorView } from '../../components/error-view/error-view';
import {
    useSelectorRolloverModuleId, useSelectorMxAPACCountryCodes
} from '../../configuration/';
import { usePopupInterceptor } from '../../routes/content/hooks/use-popup-interceptor';
import { useModuleByIdSelector } from '../../user-profiles';
import { RouteContainer } from '../helpers/styled';
import { ManageRollover } from './components/manage-rollover/manage-rollover';
import { OneRoasterLandingPage } from './components/one-roaster-landing-page/one-roaster-landing-page';
import {
    useContentIframeSource, useModuleParams
} from './hooks/use-content-iframe-src';
import {
    Iframe, LoadingView
} from '@components';
import {
    isValidUrl, isNonEmptyString
} from '@utils';

const ContentRoute = () => {
    const isOneRosterActivatedSchool = useSelectorIsOneRosterActivatedSchool();
    const moduleId = useModuleParams();
    const mxAPACCountryCodes = useSelectorMxAPACCountryCodes();
    const rolloverModuleId = useSelectorRolloverModuleId();
    const isInitialized = useSelectorIsInitialized();
    const appLoading = useSelectorAppLoading();
    const iframeSrc = useContentIframeSource();
    const isInvalidIframeSrc = !isNonEmptyString(iframeSrc) || !isValidUrl(iframeSrc);
    const { showTryCourseModal } = usePopupInterceptor();
    const moduleInfo = useModuleByIdSelector(moduleId || 0);
    const countryCode = useSelector<AppState, string>(state => state.userProfiles.data?.country?.code || 'AUS');
    const disableRollover = !isOneRosterActivatedSchool && moduleId && moduleId === parseInt(rolloverModuleId) && mxAPACCountryCodes.includes(countryCode);

    useEffect(() => {
        if(moduleId) {
            showTryCourseModal(moduleId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moduleId]);

    if (isInvalidIframeSrc) {
        if (isInitialized) return <ErrorView />;

        return null;
    }

    if (disableRollover) {
        return <ManageRollover />;
    }

    if (isOneRosterActivatedSchool && moduleInfo?.isAvailableForOneRosterSchoolOnly) {
        return <OneRoasterLandingPage moduleInfo={moduleInfo} />;
    }

    return (
        <RouteContainer id={'message'}>
            <Box width={'100%'} data-testid={'content-route'}>
                <Iframe iframeSrc={iframeSrc} />
                {appLoading === LoadingState.contentLoading && <LoadingView />}
            </Box>
        </RouteContainer>
    );
};

export { ContentRoute as default };
